/* Eda NEXT – Warenkorb-Leiste, Schnell-Kauf, Grillbox, Geschmacks-Finder */
(() => {
  if (window.__edaNext) return; window.__edaNext = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const bar = $('[data-eda-cartbar]');
  const CUR = (bar && bar.dataset.currency) || 'EUR';
  const FREE = ((bar && +bar.dataset.free) || 65) * 100;
  const fmt = c => new Intl.NumberFormat('de-DE', { style: 'currency', currency: CUR }).format(c / 100);
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastCart = null;
  const msgFor = total => total >= FREE
    ? 'Gratisversand erreicht – du sparst die Versandkosten!'
    : 'Noch ' + fmt(FREE - total) + ' bis zum Gratisversand';
  function burst(el) {
    if (reduce || !el) return;
    const r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    const cols = ['#ff6a3d', '#ffc46b', '#fff4e8', '#8e1c27'];
    for (let i = 0; i < 18; i++) {
      const p = document.createElement('i'); p.className = 'eda-pop';
      p.style.left = cx + 'px'; p.style.top = cy + 'px'; p.style.background = cols[i % 4];
      p.style.setProperty('--x', (Math.random() * 220 - 110) + 'px');
      p.style.setProperty('--y', (Math.random() * -170 - 20) + 'px');
      document.body.appendChild(p); setTimeout(() => p.remove(), 950);
    }
  }
  function renderBar(c) {
    lastCart = c;
    if (!bar) return;
    const hide = /^\/([a-z]{2}(-[a-z]{2})?\/)?(cart|checkouts?)(\/|$)/i.test(location.pathname);
    bar.classList.toggle('is-on', c.item_count > 0 && !hide);
    $('[data-eda-count]', bar).textContent = c.item_count;
    $('[data-eda-total]', bar).textContent = fmt(c.total_price);
    $('[data-eda-msg]', bar).textContent = msgFor(c.total_price);
    const pr = $('[data-eda-prog]', bar);
    pr.classList.toggle('is-full', c.total_price >= FREE);
    $('i', pr).style.width = Math.min(100, c.total_price / FREE * 100) + '%';
  }
  async function refresh() {
    try {
      const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      renderBar(c); document.dispatchEvent(new CustomEvent('eda:cart', { detail: c })); return c;
    } catch (e) {}
  }
  async function add(items) {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) { let m = 'Das hat leider nicht geklappt.'; try { m = (await r.json()).description || m; } catch (e) {} throw new Error(m); }
    return refresh();
  }
  window.EdaNext = { add, refresh, fmt, burst, FREE };
  const of = window.fetch;
  window.fetch = function (...a) {
    const u = String((a[0] && a[0].url) || a[0] || '');
    const p = of.apply(this, a);
    if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(() => setTimeout(refresh, 300)).catch(() => {});
    return p;
  };
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-eda-add]'); if (!b) return;
    e.preventDefault();
    const label = b.textContent; b.disabled = true; b.textContent = '…';
    try { await add([{ id: +b.dataset.edaAdd, quantity: 1 }]); b.textContent = '✓ Drin!'; burst(b); }
    catch (err) { b.textContent = 'Nicht verfügbar'; }
    setTimeout(() => { b.textContent = label; b.disabled = false; }, 1600);
  });
  const wide = matchMedia('(min-width: 750px)').matches, save = navigator.connection && navigator.connection.saveData;
  $$('template[data-eda-video]').forEach(t => { if (wide && !save && !reduce) t.replaceWith(t.content.cloneNode(true)); });
  $$('[data-eda-box]').forEach(root => {
    const qty = new Map();
    const btn = $('[data-eda-box-add]', root), prog = $('[data-eda-prog]', root);
    let wasFull = false;
    const priceOf = it => { const s = $('select', it); return s ? +s.selectedOptions[0].dataset.price : +it.dataset.price; };
    const idOf = it => { const s = $('select', it); return s ? +s.value : +it.dataset.variant; };
    function update() {
      let sum = 0, n = 0;
      $$('.eda-item', root).forEach(it => {
        const q = qty.get(it) || 0; it.classList.toggle('is-on', q > 0);
        $('output', it).textContent = q; sum += q * priceOf(it); n += q;
      });
      const base = lastCart ? lastCart.total_price : 0, total = base + sum;
      $('[data-eda-box-sum]', root).textContent = fmt(sum);
      $('[data-eda-box-msg]', root).textContent = n ? msgFor(total) : 'Wähle deine Lieblinge – wir zeigen dir, wie du Versand sparst.';
      $('i', prog).style.width = Math.min(100, total / FREE * 100) + '%';
      prog.classList.toggle('is-full', total >= FREE);
      if (total >= FREE && !wasFull && n) burst(prog);
      wasFull = total >= FREE; btn.disabled = !n;
      btn.textContent = n ? n + (n === 1 ? ' Artikel' : ' Artikel') + ' in den Warenkorb' : 'Box zusammenstellen';
    }
    root.addEventListener('click', e => {
      const m = e.target.closest('[data-dir]'); if (!m) return;
      const it = m.closest('.eda-item'); qty.set(it, Math.max(0, Math.min(20, (qty.get(it) || 0) + (m.dataset.dir === '+' ? 1 : -1)))); update();
    });
    root.addEventListener('change', update);
    document.addEventListener('eda:cart', update);
    btn.addEventListener('click', async () => {
      const items = $$('.eda-item', root).filter(it => qty.get(it)).map(it => ({ id: idOf(it), quantity: qty.get(it) }));
      if (!items.length) return; btn.disabled = true; btn.textContent = '…';
      try { await add(items); burst(btn); location.href = '/cart'; }
      catch (err) { btn.textContent = err.message; setTimeout(update, 2500); }
    });
    update();
  });
  $$('[data-eda-finder]').forEach(root => {
    const qs = $$('.eda-q', root), dots = $$('.eda-dots i', root), ans = {}; let i = 0;
    const show = n => { qs.forEach((q, k) => q.classList.toggle('is-active', k === n)); dots.forEach((d, k) => d.classList.toggle('on', k <= n)); };
    root.addEventListener('click', e => {
      const o = e.target.closest('.eda-opt'); if (o) {
        ans[o.dataset.key] = o.dataset.val; i++;
        if (i < qs.length) return show(i);
        const res = $$('.eda-res', root);
        if (!res.length) return;
        const score = r => (r.dataset.taste === ans.taste ? 4 : 0) + (r.dataset.spice === ans.spice ? 2 : r.dataset.spice === 'any' ? 1 : 0);
        const best = res.slice().sort((a, b) => score(b) - score(a))[0];
        qs.forEach(q => q.classList.remove('is-active')); dots.forEach(d => d.classList.add('on'));
        res.forEach(r => r.classList.toggle('is-active', r === best)); burst($('.eda-res.is-active .eda-btn', root));
      }
      if (e.target.closest('[data-restart]')) { i = 0; $$('.eda-res', root).forEach(r => r.classList.remove('is-active')); show(0); }
    });
    show(0);
  });
  refresh();
  addEventListener('pageshow', e => { if (e.persisted) refresh(); });
})();